import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupK1 } from "redux/app/annex6-v2/groups/group-k";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupK1PreviewProps = OwnProps;

function Annex6V2GroupK1Preview(props: Annex6V2GroupK1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupK1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { itemK1P1, itemK1P2 } = record;

	function renderMain() {
		const tableRows = [
			[operationDate, "K", "1", renderItemP1()],
			[null, null, "4", renderItemP2()],
		];

		if (record.remarks) {
			tableRows.push([null, null, "NOTE", record.remarks]);
		}

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		return (
			<h4 className="font-medium uppercase">
				{itemK1P1.place === "IN_PORT"
					? `EGCS failed or malfunctioned at ${itemK1P1.portName}`
					: `EGCS failed or malfunctioned at ${itemK1P1.latitude} | ${itemK1P1.longitude}`}
			</h4>
		);
	}

	function renderItemP2() {
		const {
			isCoastalStateInformedOfMalfunction,
			isFlagStateInformedOfMalfunction,
		} = itemK1P2;

		let message = "";
		if (
			isCoastalStateInformedOfMalfunction &&
			isFlagStateInformedOfMalfunction
		) {
			message =
				"Both coastal state and flag state are informed about sensor malfunction.";
		} else if (isCoastalStateInformedOfMalfunction) {
			message = "Coastal state is informed about the sensor malfunction.";
		} else if (isFlagStateInformedOfMalfunction) {
			message = "Flag state is informed about the sensor malfunction.";
		} else {
			message =
				"Neither coastal state nor flag state informed about the sensor malfunction.";
		}

		return <h4 className="font-medium uppercase">{message}</h4>;
	}

	return renderMain();
}

export default Annex6V2GroupK1Preview;
